<p-dropdown
  [showClear]="enableEmpty"
  *ngIf="items"
  (ngModelChange)="onChange($event)"
  [options]="items"
  [(ngModel)]="selection"
  [ngModelOptions]="{ standalone: isStandalone }"
  [disabled]="disabled"
  placeholder="auswählen..."
  optionLabel="indicator"
  dataKey="_id">
  <ng-template pTemplate="selectedItem">
    <div class="flex align-items-center gap-2" *ngIf="selection">
      <i class="fas fa-ruler-vertical"></i>
      <div>{{ selection.name }}</div>
    </div>
  </ng-template>
  <ng-template let-indicator pTemplate="item">
    <div class="flex align-items-center gap-2">
      <i class="fas fa-ruler-vertical"></i>
      <span>{{ indicator.name }}</span>
    </div>
  </ng-template>
</p-dropdown>
